import {UI} from "../../../../stem-core/ui/UIBase";
import {UserSession} from "../../../../client/state/UserSessionStore.js";
import {ArrayPaginator} from "../../../../stem-core/state/pagination/EndpointPaginator";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable.jsx";
import {Card} from "../../ui/Card.jsx";


export class UserSessionsList extends UI.Element {
    render() {
        const {user} = this.options;
        const userSessions = UserSession.filterBy({userId: user.id});
        const paginator = new ArrayPaginator(userSessions, 8);

        const columns = [
            ["Id", userSession => userSession.id],
            ["Created", userSession => userSession.createdAt],
            ["Ip", userSession => userSession.ip],
            ["Source", userSession => userSession.source],
            ["Social Provider", userSession => userSession.provider],
            ["Country", userSession => userSession.countryCode],
            ["Expire date", userSession => userSession.expiresAt],
            ["Logged out date", userSession => userSession.revokedAt],
            ["Origin", userSession => userSession.originMerchant],
            ["Shared with", userSession => userSession.sharedWithMerchant],
        ];

        return (
            <Card title="Sessions">
                <SimpleTable columns={columns} paginator={paginator}/>
            </Card>
        );
    }
}
